export const testo_privacy = (env: any) => {

  return `
    <div class="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-slate-900 dark:border-gray-700 dark:shadow-slate-700/[.7] mb-6">
      <div class="p-4 md:p-5">
        <div class="text-lg text-gray-800 dark:text-white">
        Il ${env.DPO_comune} gestisce i dati personali forniti e liberamente comunicati sulla base dell’articolo 13 del Regolamento (UE) 2016/679 General data protection regulation (Gdpr) e degli articoli 13 e successive modifiche e integrazioni del decreto legislativo (di seguito d.lgs) 267/2000 (Testo unico enti locali).
        </div>

        <div class="mt-2 text-lg text-gray-800">
          Per i dettagli sul trattamento dei dati personali consulta l' 
          <a class="underline text-primary" target="_blank" href="${env.privacy_link}">informativa sulla privacy.</a>
        </div>
      </div>
    </div>
  `;
};


export const testo_privacy_bonus = (env: any) => {

  return `
<div class="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-slate-900 dark:border-gray-700 dark:shadow-slate-700/[.7] mb-6">
      <div class="p-4 md:p-5">
        <div class="text-lg text-gray-800 dark:text-white">
        Il ${env.DPO_comune} gestisce i dati personali forniti e liberamente comunicati sulla base dell’articolo 13 del Regolamento (UE) 2016/679 General data protection regulation (Gdpr) e degli articoli 13 e successive modifiche e integrazioni del decreto legislativo (di seguito d.lgs) 267/2000 (Testo unico enti locali).
        </div>

        <div class="mt-2 text-lg text-gray-800">
          Per i dettagli sul trattamento dei dati personali consulta l' 
          <a class="underline text-primary" target="_blank" href="https://www.comune.sanlazzaro.bo.it/servizi/salute-benessere-e-assistenza/bonus-elettrico-per-disagio-fisico/informativa-sulla-privacy">informativa sulla privacy.</a>
        </div>
      </div>
    </div>
  `;
};

